import {
  client,
  configUtil
} from './modules/common';

import { ApolloProvider } from '@apollo/client';
import * as markerUtil from 'markerUtil';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { pdfjs } from 'react-pdf';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const { envName } = configUtil.getConfig();

if (envName !== 'devLocal' && envName !== 'prod') {
  markerUtil.init();
}
pdfjs.GlobalWorkerOptions.workerSrc = process.env.PUBLIC_URL + '/pdf.worker.js';
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>

      <App />

    </ApolloProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
